export default "__VITE_ASSET__cHoXs5ar__"